import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useSuperAdminInvite } from '@/contexts/SuperAdminInviteContext';
import TeamInvitation from '@/components/brand-team/TeamInvitation';
import { useBrandTeam } from '@/hooks/useBrandTeam';
import { useToast } from '@/hooks/use-toast';

interface GlobalInviteTeamMemberDialogProps {
  onInviteSuccess?: () => void;
}

export const GlobalInviteTeamMemberDialog: React.FC<GlobalInviteTeamMemberDialogProps> = ({ onInviteSuccess }) => {
  const { isOpen, selectedBrandId, closeInviteDialog } = useSuperAdminInvite();
  const { inviteMember, isLoading: isInviting } = useBrandTeam(selectedBrandId || undefined);
  const { toast } = useToast();

  const handleInviteMember = async (email: string, role: any, customRoleId?: string, createSquadMember?: boolean, squadType?: string) => {
    if (!selectedBrandId) return false;
    
    try {
      const success = await inviteMember(email, role, customRoleId, createSquadMember, squadType);
      if (success) {
        toast({
          title: 'Success',
          description: 'Team member invited successfully',
        });
        closeInviteDialog();
        onInviteSuccess?.();
      }
      return success;
    } catch (error) {
      console.error('Error inviting member:', error);
      return false;
    }
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeInviteDialog();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Invite Team Member</DialogTitle>
        </DialogHeader>
        {selectedBrandId && (
          <TeamInvitation
            onInviteMember={handleInviteMember}
            isInviting={isInviting}
            brandId={selectedBrandId}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
